<template>
    <Typography
        is="div"
        type="paragraph"
        size="xs"
        :responsive="false"
        :class="[$style.seo, $style[props.color]]"
    >
        <SeoTextRaw :content="props.content" />
        <img
            v-if="props.pictureData"
            :src="props.pictureData.src"
            :alt="props.pictureData.alt || ''"
            :loading="props.loading ?? 'lazy'"
            :fetchpriority="props.fetchpriority"
            :class="$style.picture"
        />
        <SeoVideo
            v-if="props.videoData"
            :videoUrl="props.videoData.videoUrl"
            :posterUrl="props.videoData.posterUrl"
            :videoType="props.videoData.videoType"
        />
    </Typography>
</template>
<script lang="ts" setup>
import SeoVideo, { type SeoVideoType } from '@/components_new/SeoVideo.vue'
import Typography from '@/components_new/Typography.vue'

import SeoTextRaw from './SeoTextRaw.vue'

const props = withDefaults(
    defineProps<{
        content: string
        color?: 'white-80' | 'white-60'
        loading?: 'lazy' | 'eager'
        fetchpriority?: 'high' | 'auto' | 'low'
        pictureData?: {
            src: string
            alt?: string
        }
        videoData?: {
            videoUrl: string
            posterUrl?: string
            videoType: SeoVideoType
        }
    }>(),
    { color: 'white-60' },
)
</script>
<style module>
.seo {
    --color: var(--white-60);
    color: var(--color);
    font-size: var(--font-size-paragraph-s);
    line-height: var(--line-height-paragraph-s);
    width: 100%;
}

.picture {
    width: clamp(100px, 100%, 448px);
    height: auto;
    border-radius: 16px;
}

.seo.white-60 {
    --color: var(--white-60);
}

.seo.white-80 {
    --color: var(--white-80);
}

.seo h1,
.seo h2,
.seo h3 {
    margin-top: 24px;
    margin-bottom: 12px;
    color: white;
    font-size: var(--font-size-header-xs);
    font-weight: var(--font-weight-accent);
    line-height: var(--line-height-header);
}

.seo h1 {
    font-size: var(--font-size-header-m);
}

.seo h1:first-child,
.seo h2:first-child {
    margin-top: 0;
}

.seo h4,
.seo h5,
.seo h6 {
    color: white;
    font-size: var(--font-size-paragraph-s);
    line-height: var(--line-height-paragraph-s);
    font-weight: var(--font-weight-accent);
}

.seo ul {
    list-style-type: disc;
    list-style-position: inside;
}
.seo a {
    color: var(--purple-600);
}

.seo a:hover,
.seo a:active {
    color: var(--experimental-salad);
}
</style>
